import { render, staticRenderFns } from "./StocktakingProfitAndLossCreate.vue?vue&type=template&id=7844f586&scoped=true&"
import script from "./StocktakingProfitAndLossCreate.vue?vue&type=script&lang=js&"
export * from "./StocktakingProfitAndLossCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844f586",
  null
  
)

export default component.exports